// Lib
import React, { useState } from 'react';
import PropTypes from 'prop-types';

// Components
import StyledButton from '../../../../../../../components/buttons/StyledButton';
import Measure from '../../../../../../../../node_module_clones/react-measure/src/Measure';

// Styles
import './PopupActionsWithConfirmationView.scss';

const getConfirmationPanelStyle = (contentWidth) => {
    if (!contentWidth) return;

    return {
        width: contentWidth,
    };
};

const PopupActionsWithConfirmationView = (props) => {
    const { children } = props;

    const [contentWidth, setContentWidth] = useState();

    const [showConfirmation, setShowConfirmation] = useState(false);
    const [confirmationMessage, setConfirmationMessage] = useState('');
    const [onConfirmationFn, setOnConfirmationFn] = useState();

    const onMeasure = ({ width }) => {
        setContentWidth(width);
    };

    const createRequireConfirmationFn =
        (onConfirmFn, warningMessage = 'Are you sure?') =>
        (e) => {
            setShowConfirmation(true);
            setConfirmationMessage(warningMessage);
            // NOTE: We need to wrap this in an anonymous function because react executes functions passed into setState
            //  because it thinks its a "functional-update" https://reactjs.org/docs/hooks-reference.html#functional-updates
            setOnConfirmationFn(() => onConfirmFn);
        };

    const onConfirmation = () => {
        onConfirmationFn && onConfirmationFn();
        setShowConfirmation(false);
    };

    const onCancel = () => {
        setShowConfirmation(false);
    };

    return (
        <div className="PopupActionsWithConfirmationView">
            {showConfirmation ? (
                <div className="confirmation-panel" style={getConfirmationPanelStyle(contentWidth)}>
                    <div className="confirmation-message">{confirmationMessage}</div>
                    <div className="confirmation-actions">
                        <StyledButton className="primary thin" onClick={onConfirmation}>
                            Yes
                        </StyledButton>
                        <StyledButton className="secondary thin" onClick={onCancel}>
                            No
                        </StyledButton>
                    </div>
                </div>
            ) : (
                <Measure whitelist={['width']} onMeasure={onMeasure} shouldMeasure>
                    <div>
                        {React.Children.map(children, (child) =>
                            React.cloneElement(child, { createRequireConfirmationFn }),
                        )}
                    </div>
                </Measure>
            )}
        </div>
    );
};

PopupActionsWithConfirmationView.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default PopupActionsWithConfirmationView;
